import {get, post} from "./http"

function CustomerAPI() {
	function status({secureCode}: {secureCode: string}) {
		return get(`/app/customers/${secureCode}`, {})
	}

	function grantESIGNConsent({customerID}: {customerID: string}) {
		return post(`/app/customer/${customerID}/grant-esign-consent`, {})
	}

	function requestESIGNConsentForm({customerID}: {customerID: string}) {
		return get(`/app/customer/${customerID}/grant-esign-consent`, {})
	}

	return {status, grantESIGNConsent, requestESIGNConsentForm}
}

export {CustomerAPI}

export const customerAPI = CustomerAPI()
